import { Language } from '../dto/languages.dto';

export enum LanguageEnum {
  'Afar' = 'aa',
  'Abkhaz' = 'ab',
  'Avestan' = 'ae',
  'Afrikaans' = 'af',
  'Akan' = 'ak',
  'Amharic' = 'am',
  'Aragonese' = 'an',
  'Arabic' = 'ar',
  'Assamese' = 'as',
  'Avaric' = 'av',
  'Aymara' = 'ay',
  'Azerbaijani' = 'az',
  'Bashkir' = 'ba',
  'Belarusian' = 'be',
  'Bulgarian' = 'bg',
  'Bislama' = 'bi',
  'Bambara' = 'bm',
  'Bengali' = 'bn',
  'Tibetan' = 'bo',
  'Breton' = 'br',
  'Bosnian' = 'bs',
  'Catalan' = 'ca',
  'Chechen' = 'ce',
  'Chamorro' = 'ch',
  'Corsican' = 'co',
  'Cree' = 'cr',
  'Czech' = 'cs',
  'Old Church Slavonic' = 'cu',
  'Chuvash' = 'cv',
  'Welsh' = 'cy',
  'Danish' = 'da',
  'German' = 'de',
  'Divehi' = 'dv',
  'Dzongkha' = 'dz',
  'Ewe' = 'ee',
  'Greek' = 'el',
  'English' = 'en',
  'Esperanto' = 'eo',
  'Spanish' = 'es',
  'Estonian' = 'et',
  'Basque' = 'eu',
  'Persian' = 'fa',
  'Fula' = 'ff',
  'Finnish' = 'fi',
  'Fijian' = 'fj',
  'Faroese' = 'fo',
  'French' = 'fr',
  'Western Frisian' = 'fy',
  'Irish' = 'ga',
  'Scottish Gaelic' = 'gd',
  'Galician' = 'gl',
  'Guaraní' = 'gn',
  'Gujarati' = 'gu',
  'Manx' = 'gv',
  'Hausa' = 'ha',
  'Hebrew' = 'he',
  'Hindi' = 'hi',
  'Hiri Motu' = 'ho',
  'Croatian' = 'hr',
  'Haitian' = 'ht',
  'Hungarian' = 'hu',
  'Armenian' = 'hy',
  'Herero' = 'hz',
  'Interlingua' = 'ia',
  'Indonesian' = 'id',
  'Interlingue' = 'ie',
  'Igbo' = 'ig',
  'Nuosu' = 'ii',
  'Inupiaq' = 'ik',
  'Ido' = 'io',
  'Icelandic' = 'is',
  'Italian' = 'it',
  'Inuktitut' = 'iu',
  'Japanese' = 'ja',
  'Javanese' = 'jv',
  'Georgian' = 'ka',
  'Kongo' = 'kg',
  'Kikuyu' = 'ki',
  'Kwanyama' = 'kj',
  'Kazakh' = 'kk',
  'Kalaallisut' = 'kl',
  'Khmer' = 'km',
  'Kannada' = 'kn',
  'Korean' = 'ko',
  'Kanuri' = 'kr',
  'Kashmiri' = 'ks',
  'Kurdish' = 'ku',
  'Komi' = 'kv',
  'Cornish' = 'kw',
  'Kyrgyz' = 'ky',
  'Latin' = 'la',
  'Luxembourgish' = 'lb',
  'Ganda' = 'lg',
  'Limburgish' = 'li',
  'Lingala' = 'ln',
  'Lao' = 'lo',
  'Lithuanian' = 'lt',
  'Luba-Katanga' = 'lu',
  'Latvian' = 'lv',
  'Malagasy' = 'mg',
  'Marshallese' = 'mh',
  'Māori' = 'mi',
  'Macedonian' = 'mk',
  'Malayalam' = 'ml',
  'Mongolian' = 'mn',
  'Marathi' = 'mr',
  'Malay' = 'ms',
  'Maltese' = 'mt',
  'Burmese' = 'my',
  'Nauru' = 'na',
  'Norwegian Bokmål' = 'nb',
  'Northern Ndebele' = 'nd',
  'Nepali' = 'ne',
  'Ndonga' = 'ng',
  'Dutch' = 'nl',
  'Norwegian Nynorsk' = 'nn',
  'Norwegian' = 'no',
  'Southern Ndebele' = 'nr',
  'Navajo' = 'nv',
  'Chichewa' = 'ny',
  'Occitan' = 'oc',
  'Ojibwe' = 'oj',
  'Oromo' = 'om',
  'Oriya' = 'or',
  'Ossetian' = 'os',
  'Panjabi' = 'pa',
  'Pāli' = 'pi',
  'Polish' = 'pl',
  'Pashto' = 'ps',
  'Portuguese' = 'pt',
  'Quechua' = 'qu',
  'Romansh' = 'rm',
  'Kirundi' = 'rn',
  'Romanian' = 'ro',
  'Russian' = 'ru',
  'Kinyarwanda' = 'rw',
  'Sanskrit' = 'sa',
  'Sardinian' = 'sc',
  'Sindhi' = 'sd',
  'Northern Sami' = 'se',
  'Sango' = 'sg',
  'Sinhala' = 'si',
  'Slovak' = 'sk',
  'Slovenian' = 'sl',
  'Samoan' = 'sm',
  'Shona' = 'sn',
  'Somali' = 'so',
  'Albanian' = 'sq',
  'Serbian' = 'sr',
  'Swati' = 'ss',
  'Southern Sotho' = 'st',
  'Sundanese' = 'su',
  'Swedish' = 'sv',
  'Swahili' = 'sw',
  'Tamil' = 'ta',
  'Telugu' = 'te',
  'Tajik' = 'tg',
  'Thai' = 'th',
  'Tigrinya' = 'ti',
  'Turkmen' = 'tk',
  'Tagalog' = 'tl',
  'Tswana' = 'tn',
  'Tonga' = 'to',
  'Turkish' = 'tr',
  'Tsonga' = 'ts',
  'Tatar' = 'tt',
  'Twi' = 'tw',
  'Tahitian' = 'ty',
  'Uyghur' = 'ug',
  'Ukrainian' = 'uk',
  'Urdu' = 'ur',
  'Uzbek' = 'uz',
  'Venda' = 've',
  'Vietnamese' = 'vi',
  'Volapük' = 'vo',
  'Walloon' = 'wa',
  'Wolof' = 'wo',
  'Xhosa' = 'xh',
  'Yiddish' = 'yi',
  'Yoruba' = 'yo',
  'Zhuang' = 'za',
  'Chinese' = 'zh',
  'Zulu' = 'zu',
}

export const ALL_LANGUAGES: Map<Language, {
  key: Language;
  name: string;
  normalizedName: string;
}> = new Map(Object.entries(LanguageEnum).map(_ => {
  return [
    _[1],
    {
      key: _[1],
      name: _[0],
      normalizedName: _[0].toLowerCase(),
    },
  ];
}));

export const ALL_LANGUAGE_BY_NAMES = new Map(Array.from(ALL_LANGUAGES.values()).map(_ => [_.normalizedName, _]));